import { useEffect, useRef, useState } from 'react'

import type { LDClient } from 'launchdarkly-react-client-sdk'

import type { FeatureFlag } from '@b-stock/fe-core/bstock-next/helpers'

/**
 * Latch a flag's variation the first time the buyer is eligible and the client
 * is ready, so the experiment population stays limited to buyers who could
 * actually see the feature.
 *
 * The latch never resets, so a mid-session LaunchDarkly change does not take
 * effect until navigation — deliberate for a stable experiment arm, at the cost
 * of a kill switch that is not immediate.
 */
export const useFlagExposure = (
  flag: FeatureFlag<boolean>,
  eligible: boolean,
  ldClient: LDClient | undefined
): boolean => {
  const [treatment, setTreatment] = useState(false)
  const exposedRef = useRef(false)

  useEffect(() => {
    if (eligible && ldClient && !exposedRef.current) {
      exposedRef.current = true
      setTreatment(Boolean(ldClient.variation(flag.key, flag.defaultValue)))
    }
  }, [eligible, ldClient, flag])

  return treatment
}
